import React, { useState, useEffect } from 'react';
import cn from 'classnames';

import { trim } from 'lodash';
import Counter from './Counter';

import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@sarawootp/ckeditor5-build-classic-underline';

const WYSIWYG = ({ name, className, hideCounter, limit, data, onChange, afterInit }) => {
  // const [isChecked, setIsChecked] = useState(false);
  const [content, setContent] = useState(data);

  useEffect(() => {
    setContent(data);
  }, [data]);

  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        data={data}
        config={{
          toolbar: ['bold', 'underline', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
        }}
        onInit={(editor) => {
          if (afterInit) {
            afterInit();
          }
        }}
        onChange={(event, editor) => {
          const _data = editor.getData();
          onChange(_data);
        }}
        onBlur={(event, editor) => {}}
        onFocus={(event, editor) => {}}
      />
      {!hideCounter && <Counter data={data} limit={limit} />}
    </div>
  );
};

export default WYSIWYG;
